import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'eva-dropdown-item',
    template: `
        <li class="dropdown-item" [ngClass]="{'-active': expand}">
          <span class="dropdown-item-container" (click)="toggleExpand()">
            <ng-content select="[label]"></ng-content>
            <i class="dropdown-icon eva-3-icon-chevron-down"></i>
          </span>

          <div class="dropdown-subcontent" *ngIf="expand">
            <ng-content select="[content]"></ng-content>
          </div>
        </li>
    `,
    styleUrls: ['./eva-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EvaDropdownItemComponent {
	@Input() expand: boolean;
  @Output() clickEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() { }

    public toggleExpand() {
      this.expand = !this.expand
      this.clickEvent.emit(this.expand)
    }
}
